import {html} from 'lit-html';

import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import {repeat} from 'lit-html/directives/repeat';
import {cache} from 'lit-html/directives/cache';
import {ifDefined} from 'lit-html/directives/if-defined';
import {mark, transition} from 'lit-transition';


import { CartItemProperties } from '../const';
import TemplateRegistry from './template-registry';

import { priceTemplate, getOptionValue, valueText } from './template-util.js';

import '../options/_import.js';

const errorsAnimation = {
    mode: 'both', // IMPORTANT: execute enter/leave at the same time, reason first block is empty which does not need to be animated
    enter: {
        active: 'cl-po--fade-enter-active',
        from: 'cl-po--fade-enter-from',
        to: 'cl-po--fade-enter-to',
    },
    leave: {
        active: 'cl-po--fade-leave-active',
        from: 'cl-po--fade-leave-from',
        to: 'cl-po--fade-leave-to',
    },
    duration: 500 // time before dom node is removed
}

// option types that do NOT have their own <label> inside the option (so the top label is linked)  REQUIRED for ADA compliance!
const hasLabel = (option) => option.type === 'text' || option.type === 'textarea'  || option.type === 'number' || option.type === 'select';

const labelTemplate = (option) => html`
    ${unsafeHTML(option.label)} ${option.value && option.params.labelValueText ?  html`<span class="cl-po--value">&nbsp;${valueText(getOptionValue(option))}</span>` : null} ${option._priceText ?  html`<span class="cl-po--price">&nbsp;${unsafeHTML(priceTemplate(option._priceText, option.params.priceTemplate))}</span>` : null}    ${option.params.info ? html`<span class="cl-po--info" data-tippy-content="${option.params.info}"></span>`: null}
`;

// options repeat template
export const optionsTemplate = (options, config, onChange, onErrorClear, getOption, suffixTemplate) => html`
    ${repeat(options, (option) => option.name, (option,optionIndex) => html`

        ${cache(option.visible ? html`
                 <div class="cl-po--option" data-option="${option.name}">
                    
                    ${option.label ? (hasLabel(option) ? // NEW: only use <label> for specific options
                        html`<label class="cl-po--label" for="${option.id}">${labelTemplate(option)}</label>`:
                        html`<div class="cl-po--label">${labelTemplate(option)}</div>`
        ) : null}
                    
                    ${TemplateRegistry.templates[option.type] ? html`
                      ${TemplateRegistry.templates[option.type](option, config, onChange, onErrorClear, getOption)}
                    `: null}
                     
                    ${option.params.help ? html`
                    <div class="cl-po--help">${unsafeHTML(option.params.help)}</div>
                    `: null}
                     
                    ${transition(option.errors && option.errors.length > 0 ? mark(html`
                    <div class="cl-po--errors">
                        ${repeat(option.errors,  (error,index) => html`
                            <div class="cl-po--error" @click=${(e) => onErrorClear(e, option, error)}>${error}</div>
                        `)}
                    </div>
                    `, `${option.id}-errors`) : mark(html`<span></span>`, 'noop'), errorsAnimation )}
                   
                     ${suffixTemplate ? suffixTemplate(option) : null}
                </div>
             `: null )}
    `)}
`;

/**
 * Efficient options template
 *
 * we use cache() directive to remove the hidden options from the dom but keep them available when they are shown again
 *
 * @param options
 * @param config
 * @param onChange
 * @param onErrorClear
 * @param onValidate only used for the test add to cart button
 * @param getOption lookup other option
 * @returns {TemplateResult}
 */
const template = (options, config, onChange, onErrorClear, onValidate, getOption) => html`
    <div class="cl-po--options">

        ${options.length > 0
                ? html`
                    ${optionsTemplate(options, config, onChange, onErrorClear, getOption)}

                    ${config.editorMode ? html`
                        <div class="cl-editor-mode">
                            <p data-live-price="${config.product.id}" ></p>
                            <p data-live-weight="${config.product.id}" ></p>
                            <p data-live-sku="${config.product.id}" ></p>
                            <button class="cl-po--swatch cl-po--swatch-button cl-po--small" @click="${(e) => onValidate(e)}">
                                Add to cart (validation test)
                            </button>
                        </div>
                    ` : null
                    }
                `
                : null
        }
        ${config.idLink ? html`
            <input type="hidden" name="properties[${CartItemProperties.OPTIONS}]" value=${config.uuid} form=${ifDefined(config.productFormLink)}>
        `: null}
    </div>
`;


export default template;